import React, { useEffect, useState } from "react";
import api from "../../utils/apiClient";
import AuctionBoletin from "../AuctionBoletin";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import FooterMovil from "../FooterMovil";
import { AdminSidebar, AdminSidebarDropdown } from "../AdminSidebar";
import "../../style/AllCarsAdmin.css";
import "../../style/BoletinPage.css";
import { useAuth } from "../../context/AuthContext.js";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";

function BoletinSubastas() {
  const [auctions, setAuctions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);
  const { authToken, logout } = useAuth();
  const [input, setInput] = useState("");
  const [username, setUsername] = useState("");
  const [selectedAuctions, setSelectedAuctions] = useState([]);
  const [recipients, setRecipients] = useState([]);
  const [showRecipientsModal, setShowRecipientsModal] = useState(false);
  const [loadingRecipients, setLoadingRecipients] = useState(false);
  const [sending, setSending] = useState(false);

  const navigate = useNavigate();

  const getuser = async () => {
    try {
      const response = await api.get("usuario/getbyToken");
      setUsername(response.data.nombre);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch data");
    }
  };

  const handleAuctionSelection = (auction, isSelected) => {
    setSelectedAuctions((prev) => {
      if (isSelected) {
        return [...prev, auction];
      }
      return prev.filter((a) => a._id !== auction._id);
    });
  };

  useEffect(() => {
    if (!authToken) {
      navigate("/");
      return;
    }
    getuser();
    const fetchAuctions = async () => {
      setLoading(true);
      try {
        // GET /auctions/ already excludes hidden ones; keep only auctions that
        // have not ended yet — you don't market a finished auction.
        const res = await api.get("auctions/");
        const now = Date.now();
        const list = (res.data || []).filter(
          (a) => a && a.Carro && new Date(a.Fin).getTime() > now
        );
        list.sort((a, b) => new Date(a.Fin) - new Date(b.Fin));
        setAuctions(list);
        setError(null);
      } catch (error) {
        console.error("Error fetching auctions:", error);
        setError("Failed to fetch data");
        setAuctions([]);
      }
      setLoading(false);
    };
    fetchAuctions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const query = input.trim().toLowerCase();
  const visibleAuctions = query
    ? auctions.filter((a) => {
        const car = a.Carro || {};
        const haystack = `${car.marca || ""} ${car.modelo || ""} ${
          car.anio || ""
        } ${car.lote || ""}`.toLowerCase();
        return haystack.includes(query);
      })
    : auctions;

  const sanitizeEmail = (raw) => {
    if (typeof raw !== "string") return null;
    const e = raw.trim().toLowerCase();
    if (!e || e === "sincorreo@honduautos.com") return null;
    // Anchored to mirror the backend sanitizeEmails — reject embedded
    // whitespace/newlines or trailing content, only a single address token.
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) return null;
    return e;
  };

  const openRecipientsModal = async () => {
    if (selectedAuctions.length === 0) {
      notification.warning({
        message: "Advertencia",
        description: "No hay subastas seleccionadas para el boletín.",
      });
      return;
    }
    setLoadingRecipients(true);
    try {
      const res = await api.get("usuario/");
      const seen = new Set();
      const list = [];
      for (const u of res.data || []) {
        const correo = sanitizeEmail(u?.correo);
        if (!correo || seen.has(correo)) continue;
        seen.add(correo);
        list.push({ correo, included: true });
      }
      setRecipients(list);
      setShowRecipientsModal(true);
    } catch (error) {
      console.error("Error fetching recipients:", error);
      notification.error({
        message: "Error",
        description: "No se pudo obtener la lista de correos.",
      });
    } finally {
      setLoadingRecipients(false);
    }
  };

  const toggleRecipient = (correo) => {
    setRecipients((prev) =>
      prev.map((r) => (r.correo === correo ? { ...r, included: !r.included } : r))
    );
  };

  const setAllRecipients = (included) => {
    setRecipients((prev) => prev.map((r) => ({ ...r, included })));
  };

  const closeRecipientsModal = () => {
    if (sending) return;
    setShowRecipientsModal(false);
  };

  const includedCount = recipients.filter((r) => r.included).length;

  const confirmSend = async () => {
    const correos = recipients.filter((r) => r.included).map((r) => r.correo);
    if (correos.length === 0) {
      notification.warning({
        message: "Advertencia",
        description: "No hay correos seleccionados.",
      });
      return;
    }
    setSending(true);
    try {
      const res = await api.post("correos/enviarSubastas/", {
        auctionIds: selectedAuctions.map((a) => a._id),
        correos,
      });
      const sent = res?.data?.sent ?? correos.length;
      notification.success({
        message: "Boletín enviado",
        description: `Se envió a ${sent} ${sent === 1 ? "correo" : "correos"}.`,
      });
      setShowRecipientsModal(false);
    } catch (error) {
      console.error("Error sending boletín:", error);
      notification.error({
        message: "Error",
        description: "No se pudo enviar el boletín. Inténtalo de nuevo.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="containers">
        <div className="main-container-admin-a boletin-page">
          <AdminSidebar username={username} onLogout={handleLogout} />
          <div className="column-info">
            <AdminSidebarDropdown onLogout={handleLogout} />
            <p className="main-admin-title-a">Enviar Boletín de Subastas</p>
            <div className="bp-toolbar">
              <div className="bp-search">
                <svg
                  className="bp-search-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="11" cy="11" r="7" />
                  <path d="m20 20-3.5-3.5" />
                </svg>
                <input
                  type="text"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Marca, modelo, lote, etc."
                />
              </div>
            </div>

            <div className="bp-list">
              {visibleAuctions.length === 0 ? (
                <p className="bp-empty">
                  {loading ? "Cargando..." : "No hay subastas activas"}
                </p>
              ) : (
                visibleAuctions.map((auction) => (
                  <AuctionBoletin
                    key={auction._id}
                    auction={auction}
                    onSelectionChange={handleAuctionSelection}
                  />
                ))
              )}
            </div>

            <div className="bp-footer">
              <span
                className={`bp-counter${
                  selectedAuctions.length === 0 ? " bp-counter--zero" : ""
                }`}
              >
                <strong>{selectedAuctions.length}</strong>{" "}
                {selectedAuctions.length === 1
                  ? "subasta seleccionada"
                  : "subastas seleccionadas"}
              </span>
              <button
                type="button"
                className="bp-send"
                onClick={openRecipientsModal}
                disabled={selectedAuctions.length === 0 || loadingRecipients}
              >
                {loadingRecipients ? "CARGANDO..." : "ENVIAR BOLETÍN"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showRecipientsModal && (
        <div
          className="bp-modal-overlay"
          role="dialog"
          aria-modal="true"
          onClick={closeRecipientsModal}
        >
          <div className="bp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="bp-modal-header">
              <h3>Confirmar destinatarios</h3>
              <button
                type="button"
                className="bp-modal-close"
                onClick={closeRecipientsModal}
                aria-label="Cerrar"
                disabled={sending}
              >
                ×
              </button>
            </div>
            <div className="bp-modal-subheader">
              <span className="bp-modal-counter">
                <strong>{includedCount}</strong> de {recipients.length}{" "}
                {recipients.length === 1 ? "correo" : "correos"}
              </span>
              <div className="bp-modal-actions">
                <button
                  type="button"
                  className="bp-modal-link"
                  onClick={() => setAllRecipients(true)}
                  disabled={sending}
                >
                  Seleccionar todos
                </button>
                <button
                  type="button"
                  className="bp-modal-link"
                  onClick={() => setAllRecipients(false)}
                  disabled={sending}
                >
                  Quitar todos
                </button>
              </div>
            </div>
            <ul className="bp-modal-list">
              {recipients.length === 0 ? (
                <li className="bp-modal-empty">No hay correos válidos disponibles.</li>
              ) : (
                recipients.map((r) => (
                  <li
                    key={r.correo}
                    className={`bp-modal-row${r.included ? "" : " is-excluded"}`}
                  >
                    <label>
                      <input
                        type="checkbox"
                        checked={r.included}
                        onChange={() => toggleRecipient(r.correo)}
                        disabled={sending}
                      />
                      <span>{r.correo}</span>
                    </label>
                  </li>
                ))
              )}
            </ul>
            <div className="bp-modal-footer">
              <button
                type="button"
                className="bp-modal-cancel"
                onClick={closeRecipientsModal}
                disabled={sending}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="bp-modal-confirm"
                onClick={confirmSend}
                disabled={sending || includedCount === 0}
              >
                {sending
                  ? "Enviando..."
                  : `Enviar a ${includedCount} ${
                      includedCount === 1 ? "correo" : "correos"
                    }`}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default BoletinSubastas;
